import { useTranslation } from 'react-i18next';

import CustomInput from 'components/common/forms/CustomInput';

const ContactDetails = ({
	contactName,
	email,
	telephone,
	handleChange,
	errorState,
	allDisabled,
}: any) => {
	const { t } = useTranslation('locationModule');

	return (
		<div className='row'>
			<h5 className='location-section-title'>{t('REGULATORY_CONTACT')}</h5>
			<div className='col-xl-3 col-lg-3 col-sm-6'>
				<div className='form-group'>
					<CustomInput
						disabled={allDisabled}
						className={
							errorState?.contactName && errorState?.contactName !== ''
								? 'input-validation-error'
								: ''
						}
						value={contactName}
						onChange={handleChange}
						name='contactName'
						label={t('NAME')!!}
						placeholder={t('NAME')}
						required={false}
						type='text'
						error={errorState?.contactName}
					/>
				</div>
			</div>
			<div className='col-xl-3 col-lg-3 col-sm-6'>
				<div className='form-group'>
					<CustomInput
						disabled={allDisabled}
						className={
							errorState?.email && errorState?.email !== ''
								? 'input-validation-error'
								: ''
						}
						value={email}
						onChange={handleChange}
						name='email'
						label={t('EMAIL')!!}
						placeholder={t('EMAIL')}
						required={false}
						type='text'
						error={errorState?.email}
					/>
				</div>
			</div>
			<div className='col-xl-3 col-lg-3 col-sm-6'>
				<div className='form-group'>
					<CustomInput
						disabled={allDisabled}
						className={
							errorState?.telephone && errorState?.telephone !== ''
								? 'input-validation-error'
								: ''
						}
						value={telephone}
						onChange={handleChange}
						name='telephone'
						label={t('PHONE')!!}
						placeholder={t('PHONE')}
						required={false}
						type='text'
						error={errorState?.telephone}
					/>
				</div>
			</div>
		</div>
	);
};

export default ContactDetails;
